@if (_project != null && stats != null) {
<button type="button" class="link-button mb-2" (click)="openDocuments()">{{app.t("ProjectPlanning.viewDocuments")}}</button>
<div class="grid2">
    <div class="bold">{{app.t("entity.Project.fields.projectNumber")}}:</div>
    <div>{{_project.projectNumber}}
        @if (!service.isProjectNumberKnown(_project.projectNumber)) {
        <span class="ml-1 mouse-default" style="color: gold;" [pTooltip]="app.t('ProjectPlanning.projectMissingInEnaio')">⚠️</span>
        }
    </div>
</div>
<div class="grid2">
    <div class="bold">{{app.t("entity.Project.fields.typeId")}}:</div>
    <div>{{service.getProjectType(_project.typeId)?.title ?? ''}}</div>
</div>
<div class="grid2">
    <div class="bold">{{app.t("ProjectPlanning.status")}}:</div>
    <div>{{_project.finished ? app.t("ProjectPlanning.statusFinished") : app.t("ProjectPlanning.statusActive")}}</div>
</div>
@if (detailed) {
<div class="grid2">
    <div class="bold">{{app.t("entity.Project.fields.startDate")}}:</div>
    <div>{{_project.startDate.format()}}</div>
</div>
}
@if (_project.deliveryDate1 != null) {
<div class="grid2">
    <div class="bold">{{app.t("entity.Project.fields.deliveryDate1")}}:</div>
    <div>{{_project.deliveryDate1?.format() ?? ''}}</div>
</div>
}
@if (_project.deliveryDate2 != null) {
<div class="grid2">
    <div class="bold">{{app.t("entity.Project.fields.deliveryDate2")}}:</div>
    <div>{{_project.deliveryDate2?.format() ?? ''}}</div>
</div>
}
@if (_project.deliveryDate3 != null) {
<div class="grid2">
    <div class="bold">{{app.t("entity.Project.fields.deliveryDate3")}}:</div>
    <div>{{_project.deliveryDate3?.format() ?? ''}}</div>
</div>
}
@if (detailed) {
<div class="grid2">
    <div class="bold">{{app.t("ProjectPlanning.endDate")}}:</div>
    <div>{{stats.endDate | date: 'dd.MM.yyyy'}}</div>
</div>
}
<div class="grid2">
    <div class="bold">{{app.t("ProjectPlanning.donePercentage")}}:</div>
    <div>{{stats.donePercentage| number:'1.0'}}% ({{stats.numFinishedEvents}} von {{stats.numEvents}})</div>
</div>
@if (detailed) {
<div class="grid2">
    <div class="bold">{{app.t("entity.CalendarEvent.fields.plannedTime")}}:</div>
    <div>{{stats.plannedTime | number:'1.2'}}</div>
</div>
<div class="grid2">
    <div class="bold">{{app.t("entity.CalendarEvent.fields.doneTime")}}:</div>
    <div>{{stats.doneTime | number:'1.2'}}</div>
</div>
}
<div class="grid2">
    <div class="bold">{{app.t("ProjectPlanning.timePercentage")}}:</div>
    <div>{{stats.timePercentage | number:'1.0'}}% ({{stats.doneTimeFinished}} von {{stats.plannedTimeFinished}})</div>
</div>
<div class="grid2">
    <div class="bold">{{app.t("ProjectPlanning.creator")}}:</div>
    <div>{{createdBy}}</div>
</div>
<div class="grid2">
    <div class="bold">{{app.t("entity.Project.fields.contactPersonId")}}:</div>
    <div>{{contactPerson}}</div>
</div>
@if (detailed) {
<div class="grid2">
    <div class="bold">{{app.t("ProjectPlanning.creationDate")}}:</div>
    <div>{{_project.creationDate | date: 'dd.MM.yyyy'}}</div>
</div>
}
@for (cf of customFields; track cf) {
<div class="grid2">
    <div class="bold">{{cf.key}}:</div>
    <div>{{cf.value}}</div>
</div>
}
@if ((_project?.description ?? '') != '') {
<div class="mt-2" [innerText]="_project.description">
</div>
}
}
